export const MIN_ZOOM_LEVEL = 80;
export const MAX_ZOOM_LEVEL = 200;
export const DEFAULT_ZOOM_LEVEL = 90;
export const COMPACT_VIEWPORT_ZOOM_FLOOR = 100;
export const COMPACT_VIEWPORT_ZOOM_QUERY = '(max-width: 820px)';

export const normalizeZoomLevel = (value) => {
  const parsed = Number.parseInt(String(value ?? ''), 10);
  if (!Number.isFinite(parsed)) {
    return DEFAULT_ZOOM_LEVEL;
  }

  return Math.min(MAX_ZOOM_LEVEL, Math.max(MIN_ZOOM_LEVEL, parsed));
};

export const readStoredZoomLevel = () => {
  try {
    return normalizeZoomLevel(window.localStorage?.getItem('zoomLevel'));
  } catch {
    return DEFAULT_ZOOM_LEVEL;
  }
};

export const resolveAppliedZoomLevel = (value, isCompactViewport = false) => {
  const normalized = normalizeZoomLevel(value);
  return isCompactViewport
    ? Math.max(COMPACT_VIEWPORT_ZOOM_FLOOR, normalized)
    : normalized;
};
